import { useEffect } from 'react';

import { useModal } from 'reservations/base/providers/ModalProvider';
import { ChecklessPaymentsDrawer } from 'reservations/checklessPayments/components/ChecklessPaymentsDrawer';
import {
  LEAVE_RECEIPTS_BEHIND_HEADER,
  SAVE_PAYMENT_SUBHEADER
} from 'reservations/checklessPayments/constants';
import { DinerAuthenticationInput } from 'reservations/dinerAccount/components/DinerAuthenticationInput';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';

const OtpModal = () => {
  const { isDinerAccountAuthenticated } = useDinerAccount();
  const {
    open,
    modalContext: { nextModal }
  } = useModal();

  useEffect(() => {
    if (isDinerAccountAuthenticated) {
      open(nextModal);
    }
  }, [isDinerAccountAuthenticated]);

  return (
    <ChecklessPaymentsDrawer
      headerText={LEAVE_RECEIPTS_BEHIND_HEADER}
      subheaderText={SAVE_PAYMENT_SUBHEADER}
    >
      <DinerAuthenticationInput hideHeader />
    </ChecklessPaymentsDrawer>
  );
};

export default OtpModal;
